import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import SEO from '../components/seo';
import '../styles/app.scss';

const zumbini = ({ data }) => {
    const { wordpressPage: post } = data;
    console.log(post);
    const test_title = post.yoast_title;
    const new_test_title = test_title.replace('&#039;', "'");
    const inlineCss = {
        maxWidth: '600px',
        marginTop: '50px',
    };
    return (
        <>
            <SEO
                title={new_test_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.content,
                        }}
                    />
                </div>
            </section>
            <section className="page-section smallestwdt respitesec padding-less-under" style={{ paddingTop: 0 }}>
                <div className="container">
                    <h2 className="bluetxt" style={{ marginBottom: '60px', textAlign: 'center' }}>What to Expect at Zumbini</h2>
                    <div className="openplft">
                        <img
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/08/Zumbini-music-and-movement-classes-Piscataway.png"
                            alt="Zumbini music and movement classes at We Rock the Spectrum Kid’s Gym Piscataway"
                        />
                    </div>
                    <div className="openprgt withmarbtm">
                        <ul className="startxt starlistspacing">
                            <li className="greentxt"><span className="bluetxt">Singing, dancing and age-appropriate movement</span></li>
                            <li className="greentxt"><span className="bluetxt">Musical instruments and sensory-friendly activities</span></li>
                            <li className="greentxt"><span className="bluetxt">Parent-child bonding and social interaction</span></li>
                            <li className="greentxt"><span className="bluetxt">Support for cognitive, emotional, motor and social development</span></li>
                            <li className="greentxt"><span className="bluetxt">An inclusive environment for neurotypical and neurodiverse children</span></li>
                            <li className="greentxt"><span className="bluetxt">All equipment and class materials provided</span></li>
                        </ul>
                        <h3 className="bluetxt" style={{ marginTop: '30px' }}>Program Information</h3>
                        <ul className="startxt starlistspacing">
                            <li className="greentxt"><span className="bluetxt">Ages newborn through four</span></li>
                            <li className="greentxt"><span className="bluetxt">A parent or caregiver must participate throughout the class</span></li>
                            <li className="greentxt"><span className="bluetxt">Tuition is charged per family</span></li>
                            <li className="greentxt"><span className="bluetxt">Eligible siblings from the same household may participate, subject to class capacity</span></li>
                            <li className="greentxt"><span className="bluetxt">Each session requires at least five registered families</span></li>
                            <li className="greentxt"><span className="bluetxt">Limited family spots are available</span></li>
                        </ul>
                    </div>
                </div>
            </section>            
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                 {/*   <h2 className="yellowtxt">Fall Class Schedule</h2> */}
                 {/*   <p><strong>$160 per 6-Week Session</strong> (1 Class Per Week)</p> */}
                    <div className="schedule-table-wrap">
                        <table className="schedule-table">
                            <thead>
                                <tr>
                                    <th>Demo Classes</th>
                              {/*      <th>Thursday Evenings</th> */}
                                    <th>Six-Week Sessions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Demo Classes">
                                        Tuesday Demo<br />
                                        September 8, 2026<br />
                                        9:15–10:00 AM<br />
                                        $20 per family<br />
                                        <a
                            href="https://ecom.roller.app/werockthespectrumpiscataway/booknow/en-us/product/2059774?date=2026-09-08"
                            className="wrtsbtn yellowbtn fullbtn"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginTop: '20px' }}
                        >
                            REGISTER FOR TUESDAY DEMO
                        </a>
                                    </td>
                              {/*      <td data-label="Thursday Evenings"></td> */}
                                    <td data-label="Six-Week Sessions">
                                        Monday Session<br />
                                        October 5–November 9, 2026<br />
                                        Mondays from 10:15–11:00 AM<br />
                                        $149 per family<br />
                                        <a
                            href="https://ecom.roller.app/werockthespectrumpiscataway/booknow/en-us/product/2059774?date=2026-10-05"
                            className="wrtsbtn yellowbtn fullbtn"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginTop: '20px' }}
                        >
                            REGISTER FOR MONDAY SESSION
                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Demo Classes">
                                        Monday Demo<br />
                                        September 28, 2026<br />
                                        10:15–11:00 AM<br />
                                        $20 per family<br />
                                        <a
                            href="https://ecom.roller.app/werockthespectrumpiscataway/booknow/en-us/product/2059774?date=2026-09-28"
                            className="wrtsbtn yellowbtn fullbtn"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginTop: '20px' }}
                        >
                            REGISTER FOR MONDAY DEMO
                        </a>
                                    </td>
                           {/*         <td data-label="Thursday Evenings">
                                        <strong>Preschool/Kinder</strong> (Ages 3–6)<br /><br />
                                        ⏱ 5:45 PM – 6:30 PM
                                    </td> */}
                                    <td data-label="Six-Week Sessions">
                                        Tuesday Session<br />
                                        September 15–October 20, 2026<br />
                                        Tuesdays from 9:15–10:00 AM<br />
                                        $149 per family<br />
                                        <a
                            href="https://ecom.roller.app/werockthespectrumpiscataway/booknow/en-us/product/2059774?date=2026-09-15"
                            className="wrtsbtn yellowbtn fullbtn"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginTop: '20px' }}
                        >
                            REGISTER FOR TUESDAY SESSION
                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container smallestwdt" style={{ maxWidth: '800px' }}>
                    <h3 className="yellowtxt">Late Enrollment</h3>
                    <p style={{ marginTop: '30px' }}>Families may join after the session begins if space remains:</p>
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Beginning week two: $125 per family</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Beginning week three: $100 per family</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>No new enrollment after the third class</li>
                    </ul>
                    <p style={{ marginTop: '30px' }}>Please direct families to call the gym before purchasing prorated enrollment.</p>
                    <h3 className="yellowtxt" style={{ marginTop: '30px' }}>Important Policies</h3>
              {/*      <p style={{ marginTop: '30px' }}><strong>Auto-Pay Commitment: </strong>Rockin' Tumblers is a monthly auto-pay program billed on the 1st of each calendar month following registration. To support student progression and consistency, all memberships require an initial 2-month minimum commitment.</p>
                    <p><strong>Cancellation Policy: </strong>After your initial 2-month term, you may cancel at any time by providing a 30-day written notice via email to info@werockthespectrumpiscataway.com.</p> */}
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Registration covers one selected weekly class for six weeks.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Tuition is nonrefundable and nontransferable after the session begins.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Missed classes are not refundable; makeups are available only if space permits.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>An instructor or facility cancellation will result in a makeup class or appropriate credit.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Grippy socks are required for participating children.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Families should not attend when experiencing contagious illness symptoms.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Enrollment is complete only after payment, required acknowledgments and the facility waiver are completed.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>If a class does not meet minimum enrollment, families may transfer to the other available class or receive a refund.</li>   
                    </ul>                     
                </div>
            </section>
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                    <h3 className="yellowtxt">Questions about Zumbini?</h3>
                    <p>Call us directly at <strong>732-339-8002</strong> or email <strong>info@werockthespectrumpiscataway.com</strong>.</p>
                </div>
            </section>
       {/*     <section
                className="whywelist page-section bg-primary text-white"
                id="contformsec"
            >
                <div className="container smallestwdt">
                    <h3 className="yellowtxt">Secure Your Gymnast's Spot Today</h3>
                    <p>Spots for our Fall classes are limited to keep class sizes small and impactful. Have questions about level placement or sibling discounts? Call us directly at <strong>732-339-8002</strong> or email <strong>info@werockthespectrumpiscataway.com</strong>.</p>
                    <div className="container flexwrap contactform_wrap">
                        <iframe
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/rockin-tumblers/"
                            title="contactform"
                        />
                    </div>
                </div>
            </section> */}
            
            <Footer />
        </>
    );
};

export default zumbini;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content            
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
